import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetObjectValuesPipe
          , ContactPreferenceValuePipe
          , ConsigneeAddressCompletePipe 
          , ReplaceNullOrUndefinedPipe
          , AddSlashInDatePipe
      } from './comon.pipes';
import { GetCompCsaRateGreaterThenZero } from './spra.pipes';


      
@NgModule({
  declarations: [
    GetObjectValuesPipe,
    ContactPreferenceValuePipe,
    ConsigneeAddressCompletePipe,
    ReplaceNullOrUndefinedPipe,
    AddSlashInDatePipe,
    GetCompCsaRateGreaterThenZero
  ],
  imports: [
    CommonModule,
  ],exports:[
    GetObjectValuesPipe,
    ContactPreferenceValuePipe,
    ConsigneeAddressCompletePipe,
    ReplaceNullOrUndefinedPipe,
    AddSlashInDatePipe,
    GetCompCsaRateGreaterThenZero
  ]
})
export class PipesModule {
    static forRoot(): ModuleWithProviders<PipesModule> {
        return {
            ngModule: PipesModule
        }
    }
}
